'use strict';

// возвращает врач или ассистент
export function getWorkerType(data)
{   
    if(data.rights.includes('doctor')) return 'doctor';
    if(data.rights.includes('assistant')) return 'assistant';
    if(data.type == "Admin") return 'admin';
    return '';
}

export function IsSelectedWorker(id)
{
    let list = localStorage.getItem('workers_id');
    let ids = [];
    if(list !== 'undefined' && list != null && list != '') ids = list.split(',');
    for(var i in ids) if(ids[i] == id) return true;
    return false;
}

// добавить пользователя в список выделенных
export function addWorker(id, name, work_type)
{
    if(IsSelectedWorker(id)) return;

    let list = localStorage.getItem('workers_id');   
    
    if(list != '') list += ','
    list += id;
    localStorage.setItem('workers_id', list);

    localStorage.setItem('workers_name_' + id, name);
    localStorage.setItem('workers_type_' + id, work_type);
}

// удалить пользователя из списка выделенных
export function deleteWorker(id)
{
    if(IsSelectedWorker(id) == false) return;
    let list = localStorage.getItem('workers_id');
    let ids = list.split(',');
    let res = '';
    for(let i in ids)
        if(ids[i] != id && ids[i] != 'null')
        {
            if(res != '') res += ',';
            res += ids[i];
        }
    localStorage.setItem('workers_id', res);
}

// очистить список выделенных
export function clearWorker()
{
    localStorage.setItem('workers_id', "");
}

// посчитать количество выделенных
export function calculateSelected()
{    
    let list = localStorage.getItem('workers_id');
/*    
    if(list == null || list == 'undefined') return 0;
    let workers = list.split(',');
    if(workers == 'undefined' || workers == null) return 0;        
*/    
    return list.split(',').length;
}

export function GetIDWarehouse()
{
    return localStorage.getItem('clinic_id');
}

export default getWorkerType;